import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'home',
    defaultMessage: 'Home',
  },
  clientList: {
    id: 'clientList',
    defaultMessage: 'Client Management',
  },
  btn: {
    addNewClient: {
      id: 'clientList.btn.addNewClient',
      defaultMessage: 'Add New Client',
    },
    revoke: {
      id: 'clientList.btn.revoke',
      defaultMessage: 'Revoke',
    },
    refresh: {
      id: 'clientList.btn.refresh',
      defaultMessage: 'Refresh',
    },
  },
  header: {
    no: {
      id: 'clientList.header.no',
      defaultMessage: 'No',
    },
    clientName: {
      id: 'clientList.header.clientName',
      defaultMessage: 'Client Name',
    },
    picEmail: {
      id: 'clientList.header.picEmail',
      defaultMessage: 'PIC Email',
    },
    apiKey: {
      id: 'clientList.header.apiKey',
      defaultMessage: 'API Key',
    },
    secretKey: {
      id: 'clientList.header.secretKey',
      defaultMessage: 'Secret Key',
    },
    createdOn: {
      id: 'clientList.header.createdOn',
      defaultMessage: 'Created On',
    },
    action: {
      id: 'clientList.header.action',
      defaultMessage: 'Action',
    },
  },
  filter: {
    clientName: {
      id: 'clientList.filter.clientName',
      defaultMessage: 'Client Name',
    },
    picEmail: {
      id: 'clientList.filter.picEmail',
      defaultMessage: 'PIC Email',
    },
  },
  formAdd: {
    labelClientName: {
      id: 'clientList.formAdd.labelClientName',
      defaultMessage: 'Client Name',
    },
    placeholderClientName: {
      id: 'clientList.formAdd.placeholderClientName',
      defaultMessage: 'Enter client name',
    },
    requiredClientName: {
      id: 'clientList.formAdd.requiredClientName',
      defaultMessage: 'Client name must not empty',
    },
    labelPicEmail: {
      id: 'clientList.formAdd.labelPicEmail',
      defaultMessage: 'PIC Email',
    },
    placeholderPicEmail: {
      id: 'clientList.formAdd.placeholderPicEmail',
      defaultMessage: 'Enter PIC email',
    },
    requiredPicEmail: {
      id: 'clientList.formAdd.requiredPicEmail',
      defaultMessage: 'PIC email must not empty',
    },
    invalidPicEmail: {
      id: 'clientList.formAdd.invalidPicEmail',
      defaultMessage: 'Email format is not valid',
    },
    buttonCreate: {
      id: 'clientList.formAdd.buttonCreate',
      defaultMessage: 'Create',
    },
    buttonCancel: {
      id: 'clientList.formAdd.buttonCancel',
      defaultMessage: 'Cancel',
    },
    labelMandatory: {
      id: 'clientList.formAdd.labelMandatory',
      defaultMessage: 'Mandatory Field',
    },
  },
  modalAdd: {
    title: {
      id: 'clientList.modalAdd.title',
      defaultMessage: 'New Client',
    },
  },
  modalDetails: {
    title: {
      id: 'clientList.modalDetails.title',
      defaultMessage: 'Client Detail',
    },
    labelClientName: {
      id: 'clientList.modalDetails.labelClientName',
      defaultMessage: 'Client Name',
    },
    labelApiKey: {
      id: 'clientList.modalDetails.labelApiKey',
      defaultMessage: 'API Key',
    },
    labelSecretKey: {
      id: 'clientList.modalDetails.labelSecretKey',
      defaultMessage: 'Secret Key',
    },
    buttonClose: {
      id: 'clientList.modalDetails.buttonClose',
      defaultMessage: 'Close',
    },
    buttonRefresh: {
      id: 'clientList.modalDetails.buttonRefresh',
      defaultMessage: 'Refresh',
    },
  },
  modalRevoke: {
    title: {
      id: 'clientList.modalRevoke.title',
      defaultMessage: 'Confirmation',
    },
    description: {
      id: 'clientList.modalRevoke.description',
      defaultMessage: 'Are you sure want to revoke this client?',
    },
    buttonCancel: {
      id: 'clientList.modalRevoke.buttonCancel',
      defaultMessage: 'Cancel',
    },
    buttonRevoke: {
      id: 'clientList.modalRevoke.buttonRevoke',
      defaultMessage: 'Revoke',
    },
  },
});
